import React, { useState, useRef, useEffect, Fragment } from "react";
import "./../components/Report.css";
import { _hasPermission } from "../../../../../../shared/helpers/access";
import { _axiosCall } from "../../../../../../shared/helpers/apicalls";
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  buildingFL,
  _replaceAbbreviations,
  _formatBed,
  propertyFL,
  SalesProgress,
  _isEqual,
  _tranformTagsQuery,
  syncURLFilters,
  syncURLSearch,
  setURLFromState,
  setLocalStorage,
  getLocalStorage,
  deleteLocalStorage,
  syncStageFilters,
  mpndCohortQuery,
  syncGenericFilter,
  urlSlugBuilding,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  houseBuildingCohortQuery,
  _activityFL,
} from "../../../../../../shared/helpers/utils";

import PropertyTypePage from "../components/PropertyTypePage";
import { formatDateRange, calculatePercentageChange, previousYearPeriod, generatePeriodNames, percentageChange, prepareResForAI, filterAIData, getCurrentPeriod, getPriorPeriod, getRangeEnd, getRangeStart, openAIModel} from "../../../exportreport/utils"
const apiURL = process.env.API_ROOT;


let statTypes = [
  {
    key: "sales",
    title: "New and Resale Condo Contracts",
    name: "Condo Market",
    checkedColor: "#780F9E",
    activitesQuery:
      '(event_tags:(condo* !condo*p) AND -address_2_normalized:"")',
    default: true,
  },
];

const statFacet = {
  avg_price: "avg(price)",
  med_price: "percentile(price, 50)",
  sum_price: "sum(price)",
  by_borough: {
    type: "terms",
    field: "borough",
    facet: {
      avg_price: "avg(price)",
      med_price: "percentile(price, 50)",
    },
  },
  ppsf: {
    type: "query",
    q: "sq_ft:[300 TO 20000]",
    facet: {
      avg: "avg(div(price, sq_ft))",
      med: "percentile(div(price, sq_ft), 50)",
    },
  },
  price_change: {
    type: "query",
    q: "price_change_amount:*",
    facet: {
      avg: "avg(price_change_amount)",
      percent: "avg(price_change_percent)",
      sum: "sum(price_change_amount)",
    },
  },
  dom: {
    type: "query",
    q: "days_on_market:[3 TO 720]",
    facet: {
      avg: "avg(days_on_market)",
      med: "percentile(days_on_market, 50)",
    },
  },
  under_one: {
    type: "query",
    q: "price:[10000 TO 999999]",
  },
  one_to_two: {
    type: "query",
    q: "price:[1000000 TO 1999999]",
  },
  two_to_four: {
    type: "query",
    q: "price:[2000000 TO 3999999]",
  },
  four_to_ten: {
    type: "query",
    q: "price:[4000000 TO 9999999]",
  },
  ten_plus: {
    type: "query",
    q: "price:[10000000 TO 350000000]",
  },
};

const Layout = (props) => {
  const {
    fetchInProgress,
    setFetchInProgress,
    user,
    reportLoaded,
    setReportLoaded,
    reportData,
    setReportData,
    searchTags,
    summarizeGeographies,
    customDate,
    submit,
    setSubmit,
    color,
    reportHeader,
    logo,
    formValues,
    setAiResponse,
    AiResponse,
    setFetchAi,
    fetchAi,
    setAIInProgress
  } = props;

  const { dateOptions } = customDate;
  const currentPeriod = getCurrentPeriod(dateOptions)
  const priorPeriod = getPriorPeriod(dateOptions)

  const priorYearPeriod = priorPeriod;
  const rangeEnd = getRangeEnd(dateOptions);
  const rangeStart = getRangeStart;
  const gap = dateOptions.gap;
  const currentPeriodName = generatePeriodNames(dateOptions).currentPeriod;
  const priorYearPeriodName = generatePeriodNames(dateOptions).priorYearPeriod;
  useEffect(() => {
    if (!reportData && !fetchInProgress && submit) {
      loadData();
      setSubmit(false)
    }
  }, [submit]);
  useEffect(() => {
    console.log(reportData, fetchAi)
      const fetchAIData = async () => {
       setFetchAi &&  setFetchAi(false);
       setAIInProgress(true);
       

     let  aiData = prepareResForAI(JSON.parse(JSON.stringify(reportData.facets)));
         const aiResponse = await handleAIGenerate(aiData);
      
   
        setAiResponse &&  setAiResponse(aiResponse);
        setAIInProgress(false);
      };
    
      if ( reportData && fetchAi) {
        fetchAIData();
        
      }
    }, [reportData, fetchAi])
  const dataFacet = {
    contract_signed: {
      type: "query",
      q: "topic:listings AND event_tags:contract-signed AND -event_tags:rent AND -event_tags:*commercial*",
      facet: {
        current_period: {
          type: "query",
          q: `time:${currentPeriod}`,
          facet: statFacet,
        },
        prior_period: {
          type: "query",
          q: `time:${priorPeriod}`,
          facet: statFacet,
        },
        prior_year_period: {
          type: "query",
          q: `time:${priorYearPeriod}`,
          facet: statFacet,
        },
        chart: {
          range: {
            field: "time",
            start: rangeStart,
            end: rangeEnd,
            gap: gap,
            facet: {
              dom: {
                type: "query",
                q: "days_on_market:[3 TO 720]",
                facet: {
                  avg: "avg(days_on_market)",
                  med: "percentile(days_on_market, 50)",
                },
              },
              ppsf: {
                type: "query",
                q: "sq_ft:[300 TO 20000]",
                facet: {
                  avg: "avg(div(price, sq_ft))",
                  med: "percentile(div(price, sq_ft), 50)",
                },
              },
            },
          },
        },
      },
    },
    new_listings: {
      type: "query",
      q: "topic:listings AND event_tags:just-listed AND -event_tags:rent AND -event_tags:*commercial*",
      facet: {
        current_period: {
          type: "query",
          q: `time:${currentPeriod}`,
          facet: statFacet,
        },
        prior_period: {
          type: "query",
          q: `time:${priorPeriod}`,
          facet: statFacet,
        },
        prior_year_period: {
          type: "query",
          q: `time:${priorYearPeriod}`,
          facet: statFacet,
        },
        chart: {
          range: {
            field: "time",
            start: rangeStart,
            end: rangeEnd,
            gap: gap,
            facet: {
              med_price: "avg(price)",
              med_price: "percentile(price, 50)",
              sum_price: "sum(price)",
              ppsf: {
                type: "query",
                q: "sq_ft:[300 TO 20000]",
                facet: {
                  avg: "avg(div(price, sq_ft))",
                  med: "percentile(div(price, sq_ft), 50)",
                },
              },
            },
          },
        },
      },
    },
    recorded_sold: {
      type: "query",
      q: "topic:transactions AND event_tags:recorded-sale AND -event_tags:*commercial* AND  -event_tags:property-type_parking-space AND -event_tags:property-type_storage-room AND -event_tags:parcels_bulk-sale",
      facet: {
        current_period: {
          type: "query",
          q: `time:${currentPeriod}`,
          facet: statFacet,
        },
        prior_period: {
          type: "query",
          q: `time:${priorPeriod}`,
          facet: statFacet,
        },
        prior_year_period: {
          type: "query",
          q: `time:${priorYearPeriod}`,
          facet: statFacet,
        },
        chart: {
          range: {
            field: "time",
            start: rangeStart,
            end: rangeEnd,
            gap: gap,
            facet: {
              med_price: "avg(price)",
              med_price: "percentile(price, 50)",
              sum_price: "sum(price)",
              ppsf: {
                type: "query",
                q: "sq_ft:[300 TO 20000]",
                facet: {
                  avg: "avg(div(price, sq_ft))",
                  med: "percentile(div(price, sq_ft), 50)",
                },
              },
            },
          },
        },
      },
    },
  };

  const loadData = async () => {
    let q = "*:*";
    let locQuery = _tranformTagsQuery(searchTags);

    if (locQuery) {
      q = locQuery;
    }

    const defaultQ = getCohortQuery(user, true);
    const fq = [
      ..._activityFQ.slice(),
      ...[
        `{!join from=alternate_keys fromIndex=we3-buildings to=building}${defaultQ}`,
      ],
    ];
    setFetchInProgress(true);
    let facet = {};
    statTypes.map((item) => {
      facet[item.key] = {
        type: "query",
        q: item.activitesQuery,
        facet: dataFacet,
      };
    });
    let axiosData = {
      url: apiURL + "/query/we3-activities-3?cache_time=1440&always-cache=true",
      method: "post",
      query: {
        q: q,
        fq: fq,
        wt: "json",
        rows: 0,
        "json.facet": facet,
      },
    };

    let res = await _axiosCall(axiosData)
      .then(async (res) => {
        let aiData;
        if (res && res.facets) {
          // aiData = prepareResForAI(JSON.parse(JSON.stringify(res.facets)));
          // const aiResponse = await handleAIGenerate(aiData);
          // res["aiResponse"] = aiResponse;
          setFetchInProgress(false);
          setReportLoaded(true);
          setSubmit(false);
          console.log(res);
          setReportData(res);
          setFetchAi &&  setFetchAi(true);
        }
        return res;
      })
      .catch((error) => {
        console.log("error: " + error);
      });
  };
  const handleAIGenerate = async (data) => {
   const prompt = `Given the following data give write a post card to a prospective home owner to show that I'm an real estate agent with deep insights to the condo market and that the owner should get in touch if they want to sell their home.  The analysis should be easy to understand for consumer audiences and be no longer than 3 sentences.  Add a seprate call_to_action sentence  asking owner to get in touch.  For contracts_signed focus only on the count of contracts and days on market (dom), for recorded_sold ignore number and focus on prices.  Abbreviate long currency so it's $1.5M, round if less than $1M.  If less than $1M use K.  Number should be in format ###,###,###  The results should be in valid raw JSON format, no formatting.  { "analysis" : "analysis in text", call_to_action: "cta in text" }
     
    The geography focuses on ${summarizeGeographies(searchTags)}
     
     Current Period: ${currentPeriodName}
     Prior Year Period: ${priorYearPeriodName}
     
     Contains the following key stats:${JSON.stringify(filterAIData(data))}`;

    const queryData = {
      messages: [
        {
          role: "system",
          content: `You are a NYC real estate expert that provides insightly data-driven analysis that are easy to understand.  You speak in a professional yet friendly manner.  Think TV or news analysts.`,
        },
        { role: "user", content: prompt },
      ],
      model: openAIModel,
      response_format: { type: "json_object" },
    };

    const axiosData = {
      url: apiURL + "/ai/chat",
      method: "post",
      query: queryData,
    };
    let aiResponse = {};
    try {
      const res = await _axiosCall(axiosData);
      console.log(res);

      if (
        res &&
        res.choices &&
        res.choices[0] &&
        res.choices[0].message &&
        res.choices[0].message.content
      ) {
        const result = res.choices[0].message.content;
        //console.log(result);
        try {
          aiResponse = JSON.parse(result);
        } catch (e) {}
      }
    } catch (error) {
      console.log("Error generating summary:", error);
    }
    return aiResponse;
  };



    if (!reportData) return null;
    return (
      <>
      {statTypes.map(type => {
        
        return<PropertyTypePage type={type} 
        {...props}
        summarizeGeographies={summarizeGeographies} 
        priorYearPeriodName={priorYearPeriodName} 
        currentPeriodName={currentPeriodName}/>
        
      })}
      </>
    )
};

export default Layout;
